import { render, staticRenderFns } from "./AddressChip.vue?vue&type=template&id=84439594&"
import script from "./AddressChip.vue?vue&type=script&lang=ts&"
export * from "./AddressChip.vue?vue&type=script&lang=ts&"
import style0 from "./AddressChip.vue?vue&type=style&index=0&id=84439594&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports